import { create } from "zustand";
import { PaymentPlanEnum } from "@/pages/Plan/components/PaymentPricing/config";
import { CampaignMarketingStrategy } from "@/pages/campaignCreate/config";

type ModalStore = {
  showModalCompleteCollaborationSuccess: boolean;
  setShowModalCompleteCollaborationSuccess: (
    showModalCompleteCollaborationSuccess: boolean
  ) => void;
  showModalFeedbackSuccess: boolean;
  setShowModalFeedbackSuccess: (showModalFeedbackSuccess: boolean) => void;
  modalFeedbackSuccessContent: string;
  setModalFeedbackSuccessContent: (modalFeedbackSuccessContent: string) => void;
  //
  showModalAddPayment: boolean;
  setShowModalAddPayment: (showModalAddPayment: boolean) => void;
  addPaymentModalTypeList: ("manual" | "auto")[];
  setAddPaymentModalTypeList: (modalTypeList: ("manual" | "auto")[]) => void;
  showModalPaymentBoundCard: boolean;
  setShowModalPaymentBoundCard: (showModalPaymentBoundCard: boolean) => void;
  showImModal: boolean;
  setShowImModal: (showImModal: boolean) => void;
  //
  upgradePlanModalVisible: boolean;
  setUpgradePlanModalVisible: (
    upgradePlanModalVisible: boolean,
    updatePlanType: "upgrade" | "downgrade" | "create" | "cancel" | "",
    updatePlanController: "releaseCampaign" | "confirmOrder" | "setting" | ""
  ) => void;
  updatePlanBudgetLimitMonthly: number | null;
  setUpdatePlanBudgetLimitMonthly: (
    updatePlanBudgetLimitMonthly: number
  ) => void;
  updatePlanBudgetLimitMonthlyIsYear: boolean;
  setUpdatePlanBudgetLimitMonthlyIsYear: (
    updatePlanBudgetLimitMonthlyIsYear: boolean
  ) => void;
  updatePlanType: "upgrade" | "downgrade" | "create" | "cancel" | "";
  setUpdatePlanType: (
    updatePlanType: "upgrade" | "downgrade" | "create" | "cancel" | ""
  ) => void;
  updatePlanController: "releaseCampaign" | "confirmOrder" | "setting" | "";
  setUpdatePlanController: (
    updatePlanController: "releaseCampaign" | "confirmOrder" | "setting" | ""
  ) => void;
  imNum: number;
  setImNum: (imNum: number) => void;
  //
  showRechargeResultModal: boolean;
  setShowRechargeResultModal: (showRechargeResultModal: boolean) => void;
  rechargeResultModalContent: string;
  setRechargeResultModalContent: (rechargeResultModalContent: string) => void;
  showCreateOrg: boolean;
  showManageOrg: boolean;
  setShowCreateOrg: (show: boolean) => void;
  setShowManageOrg: (show: boolean) => void;
  //
  showPaymentDetailsModal: boolean;
  setShowPaymentDetailsModal: (showPaymentDetailsModal: boolean) => void;
  btnConfirmAndPayLoading: boolean;
  setBtnConfirmAndPayLoading: (btnConfirmAndPayLoading: boolean) => void;
  btnConfirmAndIncBudgetLoading: boolean;
  setBtnConfirmAndIncBudgetLoading: (
    btnConfirmAndIncBudgetLoading: boolean
  ) => void;
  getChargeStatusApiLoading: boolean;
  setGetChargeStatusApiLoading: (getChargeStatusApiLoading: boolean) => void;
  //
  createSubscribeLoading: boolean;
  setCreateSubscribeLoading: (createSubscribeLoading: boolean) => void;
  planPagePaymentPlanType: PaymentPlanEnum;
  setPlanPagePaymentPlanType: (
    planPagePaymentPlanType: PaymentPlanEnum
  ) => void;
  planPagePaymentPlanIsYear: boolean;
  setPlanPagePaymentPlanIsYear: (planPagePaymentPlanIsYear: boolean) => void;
  planPagePaymentPlanBudget: string;
  setPlanPagePaymentPlanBudget: (planPagePaymentPlanBudget: string) => void;
  confirmPayWarnTitle: string;
  confirmPayErrorTitle: string;
  setConfirmPayWarnTitle: (confirmPayWarnTitle: string) => void;
  setConfirmPayErrorTitle: (confirmPayErrorTitle: string) => void;
  showModalConfirmAndIncBudget: boolean;
  setShowModalConfirmAndIncBudget: (
    showModalConfirmAndIncBudget: boolean
  ) => void;
  notLikeFeedBackModal: boolean;
  setNotLikeFeedBackModal: (notLikeFeedBackModal: boolean) => void;
  showChatBotSubscribeModal: boolean;
  setShowChatBotSubscribeModal: (showChatBotSubscribeModal: boolean) => void;
  showShareProductCodeModal: boolean;
  setShareProductCodeModal: (showShareProductCodeModal: boolean) => void;
  showPaymethodModal: boolean;
  setPaymethodModal: (showPaymethodModal: boolean) => void;
  showChargeModal: boolean;
  setShowChargeModal: (showChargeModal: boolean) => void;
  changeBudgetModalInfo: {
    visible: boolean;
    campaignId: string;
    budget: number | null;
    marketingStrategy: CampaignMarketingStrategy;
  };
  setChangeBudgetModalInfo: ({
    visible,
    campaignId,
    budget,
    marketingStrategy,
  }: {
    visible: boolean;
    campaignId: string;
    budget: number | null;
    marketingStrategy: CampaignMarketingStrategy;
  }) => void;
  payPlace: string; // 触发付款的位置，用于区分触发什么提示框
  setPayPlace: (payPlace: string) => void;
  campaignDetails: object; // campaign详情 用于某些不方便取数据的组件
  setCampaignDetails: (campaignDetails: object) => void;
  matchInfluencerAdjustModalInfo: {
    visible: boolean;
    intro: string;
    coreFeature: string[];
    coreAudience: { audience_description: string }[];
    campaignId: string;
    updateFunc?: Function;
  };
  setMatchInfluencerAdjustModalInfo: ({
    visible,
    intro,
    coreFeature,
    coreAudience,
    campaignId,
    updateFunc,
  }: {
    visible: boolean;
    intro: string;
    coreFeature: string[];
    coreAudience: { audience_description: string }[];
    campaignId: string;
    updateFunc?: Function;
  }) => void;
  showApproveInfluencerEffortlesslyModal: boolean;
  setShowApproveInfluencerEffortlesslyModal: (
    showApproveInfluencerEffortlesslyModal: boolean
  ) => void;
  showNotFindInfluencersModal: boolean;
  setShowNotFindInfluencersModal: (
    showNotFindInfluencersModal: boolean
  ) => void;
  showAffiliateNoRechargeModal: boolean;
  setShowAffiliateNoRechargeModal: (
    showAffiliateNoRechargeModal: boolean
  ) => void;
  chargeModalInfo: {
    amount: number | null;
  };
  setChargeModalInfo: (chargeModalInfo: {
    amount: number | null;
  }) => void;
  checkDepositModalInfo: {
    visible: boolean;
    amount: number | null;
    isActiveCampaign?: boolean;
  };
  setCheckDepositModalInfo: (checkDepositModalInfo: {
    visible: boolean;
    amount: number | null;
    isActiveCampaign?: boolean;
  }) => void;
  showPublishedVideoModal: boolean;
  setShowPublishedVideoModal: (showPublishedVideoModal: boolean) => void;
  rateModalInfo: {
    visible: boolean;
    influencerInfo: {
      creatorName: string;
      creatorAvatarUrl: string;
      platform: string;
      price: number;
    },
    rate: number;
    comment: string;
    orderId: string;
    updateFunc?: Function;
    isEdit?: boolean;
  };
  setRateModalInfo: (rateModalInfo: {
    visible: boolean;
    influencerInfo: {
      creatorName: string;
      creatorAvatarUrl: string;
      platform: string;
      price: number;
    },
    rate: number;
    comment: string;
    orderId: string;
    updateFunc?: Function;
    isEdit?: boolean;
  }) => void;
  showInfluencerTrackLinkModalInfo: {
    visible: boolean;
    orderId: string;
    campaignId: string;
    isContent: boolean;
    updateFunc?: Function;
    link?: string;
  };
  setShowInfluencerTrackLinkModalInfo: (showInfluencerTrackLinkModalInfo: {
    visible: boolean;
    orderId: string;
    campaignId: string;
    isContent: boolean;
    updateFunc?: Function;
    link?: string;
  }) => void;
  // KeepOrRemoveCreatorModal
  showKeepOrRemoveCreatorModalInfo: {
    visible: boolean;
    campaignId: string;
    updateFunc?: Function;
  };
  setShowKeepOrRemoveCreatorModalInfo: (showKeepOrRemoveCreatorModalInfo: {
    visible: boolean;
    campaignId: string;
    updateFunc?: Function;
  }) => void;
};

export const useModalStore = create<ModalStore>((set, get) => ({
  showModalCompleteCollaborationSuccess: false,
  setShowModalCompleteCollaborationSuccess: (
    showModalCompleteCollaborationSuccess: boolean
  ) => set({ showModalCompleteCollaborationSuccess }),
  showModalFeedbackSuccess: false,
  setShowModalFeedbackSuccess: (showModalFeedbackSuccess: boolean) =>
    set({ showModalFeedbackSuccess }),
  modalFeedbackSuccessContent: "",
  setModalFeedbackSuccessContent: (modalFeedbackSuccessContent: string) =>
    set({ modalFeedbackSuccessContent }),
  //
  showModalAddPayment: false,
  setShowModalAddPayment: (showModalAddPayment: boolean) =>
    set({ showModalAddPayment }),
  addPaymentModalTypeList: ["manual", "auto"],
  setAddPaymentModalTypeList: (modalTypeList: ("manual" | "auto")[]) =>
    set({ addPaymentModalTypeList: modalTypeList }),
  showModalPaymentBoundCard: false,
  setShowModalPaymentBoundCard: (showModalPaymentBoundCard: boolean) =>
    set({ showModalPaymentBoundCard }),
  showImModal: false,
  setShowImModal: (showImModal: boolean) => set({ showImModal }),
  //
  upgradePlanModalVisible: false,
  setUpgradePlanModalVisible: (
    upgradePlanModalVisible: boolean,
    updatePlanType: "upgrade" | "downgrade" | "create" | "cancel" | "",
    updatePlanController: "releaseCampaign" | "confirmOrder" | "setting" | ""
  ) => set({ upgradePlanModalVisible, updatePlanType, updatePlanController }),
  updatePlanType: "",
  setUpdatePlanType: (
    updatePlanType: "upgrade" | "downgrade" | "create" | "cancel" | ""
  ) => set({ updatePlanType }),
  updatePlanBudgetLimitMonthly: 0,
  setUpdatePlanBudgetLimitMonthly: (updatePlanBudgetLimitMonthly: number) =>
    set({ updatePlanBudgetLimitMonthly }),
  updatePlanBudgetLimitMonthlyIsYear: false,
  setUpdatePlanBudgetLimitMonthlyIsYear: (
    updatePlanBudgetLimitMonthlyIsYear: boolean
  ) => set({ updatePlanBudgetLimitMonthlyIsYear }),
  updatePlanController: "releaseCampaign",
  setUpdatePlanController: (
    updatePlanController: "releaseCampaign" | "confirmOrder" | "setting" | ""
  ) => set({ updatePlanController }),
  // imNum
  imNum: 0,
  setImNum: (imNum: number) => set({ imNum }),
  //
  showRechargeResultModal: false,
  setShowRechargeResultModal: (showRechargeResultModal: boolean) =>
    set({ showRechargeResultModal }),
  rechargeResultModalContent: "",
  setRechargeResultModalContent: (rechargeResultModalContent: string) =>
    set({ rechargeResultModalContent }),
  showCreateOrg: false,
  showManageOrg: false,
  setShowCreateOrg: (show: boolean) => set({ showCreateOrg: show }),
  setShowManageOrg: (show: boolean) => set({ showManageOrg: show }),
  //
  showPaymentDetailsModal: false,
  setShowPaymentDetailsModal: (showPaymentDetailsModal: boolean) =>
    set({ showPaymentDetailsModal }),
  btnConfirmAndPayLoading: false,
  setBtnConfirmAndPayLoading: (btnConfirmAndPayLoading: boolean) =>
    set({ btnConfirmAndPayLoading }),
  btnConfirmAndIncBudgetLoading: false,
  setBtnConfirmAndIncBudgetLoading: (btnConfirmAndIncBudgetLoading: boolean) =>
    set({ btnConfirmAndIncBudgetLoading }),
  getChargeStatusApiLoading: false,
  setGetChargeStatusApiLoading: (getChargeStatusApiLoading: boolean) =>
    set({ getChargeStatusApiLoading }),
  //
  createSubscribeLoading: false,
  setCreateSubscribeLoading: (createSubscribeLoading: boolean) =>
    set({ createSubscribeLoading }),
  planPagePaymentPlanIsYear: true,
  setPlanPagePaymentPlanIsYear: (planPagePaymentPlanIsYear: boolean) =>
    set({ planPagePaymentPlanIsYear }),
  planPagePaymentPlanType: PaymentPlanEnum.PAY_AS_YOU_GO,
  setPlanPagePaymentPlanType: (planPagePaymentPlanType: PaymentPlanEnum) =>
    set({ planPagePaymentPlanType }),
  planPagePaymentPlanBudget: "1500",
  setPlanPagePaymentPlanBudget: (planPagePaymentPlanBudget: string) =>
    set({ planPagePaymentPlanBudget }),
  confirmPayWarnTitle: "",
  confirmPayErrorTitle: "",
  setConfirmPayWarnTitle: (confirmPayWarnTitle: string) =>
    set({ confirmPayWarnTitle }),
  setConfirmPayErrorTitle: (confirmPayErrorTitle: string) =>
    set({ confirmPayErrorTitle }),
  showModalConfirmAndIncBudget: false,
  setShowModalConfirmAndIncBudget: (showModalConfirmAndIncBudget: boolean) =>
    set({ showModalConfirmAndIncBudget }),
  notLikeFeedBackModal: false,
  setNotLikeFeedBackModal: (notLikeFeedBackModal: boolean) =>
    set({ notLikeFeedBackModal }),
  showChatBotSubscribeModal: false,
  setShowChatBotSubscribeModal: (showChatBotSubscribeModal: boolean) =>
    set({ showChatBotSubscribeModal }),
  showShareProductCodeModal: false,
  setShareProductCodeModal: (showShareProductCodeModal: boolean) =>
    set({ showShareProductCodeModal }),
  showPaymethodModal: false,
  setPaymethodModal: (showPaymethodModal: boolean) =>
    set({ showPaymethodModal }),
  showChargeModal: false,
  setShowChargeModal: (showChargeModal: boolean) => set({ showChargeModal }),
  chargeModalInfo: {
    amount: null,
  },
  setChargeModalInfo: (chargeModalInfo: {
    amount: number | null;
  }) => set({ chargeModalInfo }),
  changeBudgetModalInfo: {
    visible: false,
    campaignId: "",
    budget: null,
    marketingStrategy: CampaignMarketingStrategy.INFLUENCER_MARKETING,
  },
  setChangeBudgetModalInfo: (changeBudgetModalInfo: {
    visible: boolean;
    campaignId: string;
    budget: number | null;
    marketingStrategy: CampaignMarketingStrategy;
  }) => set({ changeBudgetModalInfo }),
  payPlace: "", // 触发付款的位置，用于区分触发什么提示框  orderList: 达人列表
  setPayPlace: (payPlace: string) => set({ payPlace }),
  campaignDetails: {}, // campaign详情 用于某些不方便取数据的组件: ChargeModal
  setCampaignDetails: (campaignDetails: object) => set({ campaignDetails }),
  matchInfluencerAdjustModalInfo: {
    visible: false,
    intro: "",
    coreFeature: [],
    coreAudience: [],
    campaignId: "",
    updateFunc: () => {},
  },
  setMatchInfluencerAdjustModalInfo: (matchInfluencerAdjustModalInfo: {
    visible: boolean;
    intro: string;
    coreFeature: string[];
    coreAudience: { audience_description: string }[];
    campaignId: string;
    updateFunc?: Function;
  }) => set({ matchInfluencerAdjustModalInfo }),
  showApproveInfluencerEffortlesslyModal: false,
  setShowApproveInfluencerEffortlesslyModal: (
    showApproveInfluencerEffortlesslyModal: boolean
  ) => set({ showApproveInfluencerEffortlesslyModal }),
  showNotFindInfluencersModal: false,
  setShowNotFindInfluencersModal: (
    showNotFindInfluencersModal: boolean
  ) => set({ showNotFindInfluencersModal }),
  showAffiliateNoRechargeModal: false,
  setShowAffiliateNoRechargeModal: (
    showAffiliateNoRechargeModal: boolean
  ) => set({ showAffiliateNoRechargeModal }),
  checkDepositModalInfo: {
    visible: false,
    amount: null,
    isActiveCampaign: false,
  },
  setCheckDepositModalInfo: (checkDepositModalInfo: {
    visible: boolean;
    amount: number | null;
    isActiveCampaign?: boolean;
  }) => set({ checkDepositModalInfo }),
  showPublishedVideoModal: false,
  setShowPublishedVideoModal: (showPublishedVideoModal: boolean) =>
    set({ showPublishedVideoModal }),
  rateModalInfo: {
    visible: false,
    influencerInfo: {
      creatorName: "",
      creatorAvatarUrl: "",
      platform: "",
      price: 0,
    },
    rate: 0,
    comment: "",
    orderId: "",
    updateFunc: () => {},
    isEdit: false,
  },
  setRateModalInfo: (rateModalInfo: {
    visible: boolean;
    influencerInfo: {
      creatorName: string;
      creatorAvatarUrl: string;
      platform: string;
      price: number;
    },
    rate: number;
    comment: string;
    orderId: string;
    updateFunc?: Function;
    isEdit?: boolean;
  }) => set({ rateModalInfo }),
  showInfluencerTrackLinkModalInfo: {
    visible: false,
    orderId: "",
    campaignId: "",
    isContent: false,
    updateFunc: () => {},
    link: "",
  },
  setShowInfluencerTrackLinkModalInfo: (showInfluencerTrackLinkModalInfo: {
    visible: boolean;
    orderId: string;
    campaignId: string;
    isContent: boolean;
    updateFunc?: Function;
    link?: string;
  }) => set({ showInfluencerTrackLinkModalInfo }),
  showKeepOrRemoveCreatorModalInfo: {
    visible: false,
    campaignId: "",
    updateFunc: () => {},
  },
  setShowKeepOrRemoveCreatorModalInfo: (showKeepOrRemoveCreatorModalInfo: {
    visible: boolean;
    campaignId: string;
    updateFunc?: Function;
  }) => set({ showKeepOrRemoveCreatorModalInfo }),
}));
